import { Skeleton, TableCell, TableRow } from '@mui/material'
import { Column } from './SmartTableDefinitions'

interface P {
    columns?: Column[]
}

function LoadingRow({ columns }: P) {
    const noHiddenColumn = columns.filter(x => !x.hidden)

    return (
        <TableRow style={{ height: LOADING_ROW_HEIGHT }}>
            {noHiddenColumn.map((_, i) => {
                return (
                    <TableCell
                        key={i}
                        align={columns?.at(i)?.numeric ? 'right' : 'left'}>
                        <Skeleton sx={{ width: '80%' }} />
                    </TableCell>
                )
            })}
        </TableRow>
    )
}

export default LoadingRow

export const LOADING_ROW_HEIGHT = 40
